import { isProd, isStage } from 'shared/helpers/env'
import { CoverParts, Locales } from 'shared/types/global'

const CHILI_ENV = isProd() ? 'cp-ehn-483' : 'cp-yis-415'

const config = {
  // Debug mode may be used if you need to get specific behavior in some parts of the app for debugging purposes
  debugMode: !isStage() ? true : false,
  defaultFont: 'Inter',
  defaultLocale: Locales.de,
  supportedLocales: [Locales.de, Locales.en],
  intercomAppId: 'af64lt83',
  chiliEnvironmentUrl: `https://${CHILI_ENV}.chili-publish${!isProd() ? '-sandbox' : ''
    }.online/${CHILI_ENV}`,
  chiliWorkspaceId: 'db69f975-2eda-4389-84d3-4166b349019e',
  chiliAdminWorkspaceId: isProd() ? 'e2b4b3b9-6db0-4bfb-8ec7-ea07fd9b64ea' : '29962a73-49f9-4864-bc8c-f0b07eab9dd6',
  chiliViewPreferencesId: isProd()
    ? '0341022f-5ade-4021-9d8a-21a591a7d3ac'
    : 'd22b43ec-eafa-4da7-91f4-def560f21a7b',
  themeColors: [
    'theme_color_1',
    'theme_color_2',
    'theme_color_3',
    // Some templates mistakingly used style_color_[number] instead of theme_color_[number]
    'style_color_1',
    'style_color_2',
    'style_color_3'
  ],
  themes: {
    variablesKeys: {
      backgroundImage: 'background_image',
      themeColorPrefix: 'template_color_',
      themeColor: (number: number) =>
        `${config.themes.variablesKeys.themeColorPrefix}${number}`,
      pageNumberColor: 'page_number_color',
      pageNumberVisibility: 'page_number_visibility',
      pageNumber: 'page_number',
      cover: {
        pagesCount: 'pages',
        coverType: 'cover',
        background: {
          image: {
            [CoverParts.back]: 'frame_image_left',
            [CoverParts.spine]: 'frame_image_spine',
            [CoverParts.front]: 'frame_image_right',
          },
          color: {
            [CoverParts.back]: 'frame_color_left',
            [CoverParts.spine]: 'frame_color_spine',
            [CoverParts.front]: 'frame_color_right',
          }
        },
        spine: {
          text: 'title_text',
          textColor: 'frame_color_spine_text'
        }
      }
    }
  },
  intercom: {
    articles: {
      orderHelp: 6532154
    }
  },
  maintainableScreenWidthBreakpoint: 750,
  projectNameRegExp: /^[A-Za-z0-9]+(?:\s[A-Za-z0-9]+)*$/
}

export default config
